import { BuildingOfficeIcon } from '@heroicons/react/24/outline'
import { Tile } from '@/components/carbon'
import EmptyState from '@/components/shared/EmptyState'

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- public prop type kept as is (additive-only interfaces)
  tenants: any[]
  selectedTenantId?: string
  onTenantSelect: (tenantId?: string) => void
}

/**
 * Empty state shown to global admins on the Command Center until a tenant is
 * picked. Tenant selection lives in the side nav's tenant switcher, so this
 * points there instead of rendering a picker. A Carbon tile holding the
 * shared EmptyState (headline, then body).
 */
export default function DashboardEmptyState({ tenants }: Props) {
  const count = tenants.length
  return (
    <section aria-label="Choose a tenant" className="mt-8 max-w-[56rem]">
      <Tile padding={24}>
        <EmptyState
          icon={BuildingOfficeIcon}
          headline="Pick a tenant to open its Command Center."
          body={`You have access to ${count} ${count === 1 ? 'tenant' : 'tenants'}. The tenant switcher sits at the top of the side nav.`}
        />
      </Tile>
    </section>
  )
}
